<template>
  <div class="ledgerDigProcessSettings">
    <basic-container>
      <el-tabs v-model="activeName">
        <el-tab-pane label="流程设置" name="1">
          <el-form
            label-width="54px"
            v-loading="loading"
            element-loading-text="拼命加载中"
            element-loading-spinner="el-icon-loading"
          >
            <el-form-item
              label="审批流程："
              labelWidth="150"
              v-if="permissions['chain:ledgerDigProcessSettings:open']"
            >
              <el-switch
                v-model="isOpen"
                :active-text="isOpen ? '开启' : '关闭'"
              ></el-switch>
              <!-- <span style="color:red;margin-left:20px;font-size:14px">更改状态后请记得提交哦!</span> -->
            </el-form-item>
            <div class="steps">
              <div class="steps-label">台班审批流程：</div>
              <div class="step_box">
                <div
                  class="step"
                  v-for="(v, i) in list"
                  :key="i"
                  v-if="list && list.length > 0"
                >
                  <div class="list">
                    <!-- <div class="btn">
                      <el-button type="text" @click="del('list', i)"
                        >删除</el-button
                      >
                    </div> -->
                    <div class="title">
                      <img
                        src="@/static/waybill/people.png"
                        alt=""
                        @click="showPopover(v, i)"
                      />
                      {{getCheckTitle(i + 1) }}
                    </div>
                    <div class="content">
                      <el-form-item label="职位：">
                        <avue-select
                          v-model="v.companyPositionId"
                          placeholder="请选择职位"
                          type="tree"
                          multiple
                          :tags="true"
                          dataType="string"
                          :dic="positionList"
                        ></avue-select>
                      </el-form-item>
                      <!-- <i
                        class="el-icon-user"
                        @click="showPopover(v, i)"
                        style="
                          cursor: pointer;
                          position: absolute;
                          right: 8px;
                          top: 28px;
                          font-size: 18px;
                        "
                      ></i> -->
                    </div>
                    <div class="btn">
                      <el-button
                        type="primary"
                        class="custom-btn"
                        plain
                        @click="del('list', i)"
                        >删除</el-button
                      >
                    </div>
                  </div>
                  <div class="next-step-icon">
                    <i class="el-icon-arrow-right" v-if="i < 8"></i>
                  </div>
                </div>
                <div
                  class="add"
                  @click="addBefore('list')"
                  v-if="list && list.length < 9"
                >
                  <el-button
                    size="small"
                    plain
                    type="primary"
                    icon="el-icon-plus"
                    style="
                      margin-bottom: 0;
                      background: #fff;
                    "
                  >
                    添加
                  </el-button>
                  <!-- <i class="el-icon-plus"></i> -->
                </div>
              </div>
            </div>
            <div class="steps">
              <div class="steps-label">商务审批流程：</div>
              <div class="step_box">
                <div
                  class="step"
                  v-for="(v, i) in list2"
                  :key="i"
                  v-if="list2 && list2.length > 0"
                >
                  <div class="list">
                    <!-- <div class="btn">
                      <el-button type="text" @click="del('list2', i)"
                        >删除</el-button
                      >
                    </div> -->
                    <div class="title">
                      <img
                        src="@/static/waybill/people.png"
                        alt=""
                        @click="showPopover(v, i)"
                      />
                      {{getCheckTitle(i + 1) }}
                    </div>
                    <div class="content">
                      <el-form-item label="职位：">
                        <avue-select
                          v-model="v.companyPositionId"
                          placeholder="请选择职位"
                          type="tree"
                          multiple
                          :tags="true"
                          dataType="string"
                          :dic="positionList"
                        ></avue-select>
                      </el-form-item>
                      <!-- <i
                        class="el-icon-user"
                        @click="showPopover(v, i)"
                        style="
                          cursor: pointer;
                          position: absolute;
                          right: 8px;
                          top: 28px;
                          font-size: 18px;
                        "
                      ></i> -->
                    </div>
                    <div class="btn">
                      <el-button
                        type="primary"
                        class="custom-btn"
                        plain
                        @click="del('list', i)"
                        >删除</el-button
                      >
                    </div>
                  </div>
                  <div class="next-step-icon">
                    <i class="el-icon-arrow-right" v-if="i < 8"></i>
                  </div>
                </div>
                <div
                  class="add"
                  @click="addBefore('list2')"
                  v-if="list2 && list2.length < 9"
                >
                  <el-button
                    size="small"
                    plain
                    type="primary"
                    icon="el-icon-plus"
                    style="
                      margin-bottom: 0;
                      background: #fff;
                    "
                  >
                    添加
                  </el-button>
                </div>
              </div>
            </div>
            <div
              class="confirm-box"
              v-if="permissions['chain:ledgerDigProcessSettings:save']"
            >
              <el-button
                type="primary"
                size="medium"
                style="padding: 8px 18px; font-size: 14px"
                @click="confirm"
                >保存</el-button
              >
            </div>
          </el-form>
        </el-tab-pane>
        <el-tab-pane label="修改记录" name="2">
          <editLog
            @viewFlow="viewFlow"
            :approveType="form.approveType"
            ref="editLog"
          >
            <avue-form
              :option="option"
              v-model="form"
              @submit="submit"
              ref="form"
            ></avue-form>
          </editLog>
        </el-tab-pane>
      </el-tabs>
    </basic-container>
    <poPerson
      v-if="personVisible"
      :personNames="personNames"
      :visible.sync="personVisible"
    ></poPerson>
    <flowView
      v-if="flowVisible"
      :flowList="flowList"
      :visible.sync="flowVisible"
    ></flowView>
  </div>
</template>

<script>
import {
  getPage,
  addObj,
  getPositionList,
} from "@/api/chain/ledgerDigProcessSettings";
import { getCompanyStaffByPositionId } from "@/api/chain/waybillProcessSettings";
import { mapGetters } from "vuex";
import poPerson from "@/views/chain/waybillProcessSettings/poPerson";
import editLog from "@/views/chain/waybillProcessSettings/editLog";
import flowView from "@/views/chain/waybillProcessSettings/flowView";
import { convertToChinaNum } from "@/util/util";
export default {
  name: "ledgerDigProcessSettings",
  components: {
    poPerson,
    editLog,
    flowView,
  },
  data() {
    return {
      list: [],
      list2: [],
      positionList: [],
      isOpen: false,
      nums: ["一", "二", "三", "四", "五", "六", "七", "八", "九"],
      loading: false,
      personNames: "",
      personVisible: false,
      activeName: "1",
      flowList: [],
      flowVisible: false,
      approveType: "2,3",
      option: {
        submitBtn: true,
        emptyBtn: true,
        labelWidth: 80,
        menuSpan: 6,
        submitBtnIcon: "",
        submitText: "搜索",
        submitIcon: "el-icon-search",
        column: [
          {
            label: "审核流程",
            prop: "approveType",
            type: "select",
            span: 6,
            clearable: false,
            dicData: [
              {
                label: "全部",
                value: "2,3",
              },
              {
                label: "台班审批流程",
                value: "2",
              },
              {
                label: "商务审批流程",
                value: "3",
              },
            ],
          },
        ],
      },
      form: {
        approveType: "2,3",
      },
    };
  },
  created() {
    //获取流程列表
    this.getPage();
    //获取职位选择列表
    this.getPositionList();
  },
  computed: {
    ...mapGetters(["permissions"]),
  },
  methods: {
    getCheckTitle(val){
      return `第${convertToChinaNum(val)}审批人`
    },
    getPage() {
      this.loading = true;
      getPage()
        .then((res) => {
          this.loading = false;
          this.list = res.data.data.ledgerDigFlowList || [];
          this.list2 = res.data.data.ledgerDigSignFlowList || [];
          this.isOpen = res.data.data.ledgerDigApprove == 1;
        })
        .catch(() => {
          this.loading = false;
        });
    },
    getPositionList() {
      getPositionList().then((res) => {
        this.positionList = res.data.data.map((item) => {
          return {
            label: item.positionName,
            value: item.id,
          };
        });
      });
    },
    addBefore(list) {
      this[list].push({ companyPositionId: "" });
    },
    del(list, i) {
      this[list].splice(i, 1);
    },
    confirm() {
      if (this.isOpen == 1 && this.list.length == 0 && this.list2.length == 0) {
        this.$message.error(`开启审批流程时，审批流程必需添加审批职位!`);
        return false;
      }
      let listIsEmpty = true;
      let list2IsEmpty = true;
      if (this.list && this.list.length > 0) {
        listIsEmpty = this.list.every((item, index) => {
          if (item.companyPositionId == "") {
            this.$message.error(
              `请选择配置台班审批流程第${index + 1}步的审批职位`
            );
          }
          return item.companyPositionId != "";
        });
      }
      if (!listIsEmpty) return false;
      if (this.list2 && this.list2.length > 0) {
        list2IsEmpty = this.list2.every((item, index) => {
          if (item.companyPositionId == "") {
            this.$message.error(
              `请选择配置商务审批流程第${index + 1}步的审批职位`
            );
          }
          return item.companyPositionId != "";
        });
      }
      let param = {
        ledgerDigFlowList: this.list.map((item, index) => {
          return {
            companyPositionId: item.companyPositionId,
            approveStep: index + 1,
          };
        }),
        ledgerDigSignFlowList: this.list2.map((item, index) => {
          return {
            companyPositionId: item.companyPositionId,
            approveStep: index + 1,
          };
        }),
        ledgerDigApprove: this.isOpen ? 1 : 0,
      };
      if (list2IsEmpty && listIsEmpty) {
        this.loading = true;
        addObj(param)
          .then((res) => {
            this.loading = false;
            this.$message.success("更新成功");
            this.getPage();
            //更新记录
            this.$refs.editLog.refreshChange();
          })
          .catch(() => {
            this.loading = false;
          });
      }
    },
    showPopover(item, index) {
      if (!item.companyPositionId) {
        this.$message.error("请选择职位!");
        return false;
      }
      let param = {
        companyPositionIdList: item.companyPositionId.split(","),
      };
      getCompanyStaffByPositionId(param).then((res) => {
        this.personNames = res.data.data;
        this.personVisible = true;
      });
    },
    viewFlow(list, done) {
      this.flowList = list;
      this.flowVisible = true;
      done();
    },
    submit(form, done) {
      console.log(this.$refs.editLog);
      let obj = Object.assign({}, form);
      if (obj.approveType == "") {
        obj.approveType = "2,3";
      }
      this.$refs.editLog.searchChange(obj, done);
    },
  },
};
</script>

<style lang="scss" scoped>
.ledgerDigProcessSettings {
  height: 100%;
  .steps {
    display: flex;
    align-items: flex-start;
    // border-bottom: 1px dotted #bbb;
    margin-bottom: 20px;
    .steps-label {
      min-width: 140px;
      font-size: 14px;
      color: #606266;
    }
  }
  .step_box {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    /deep/ .step {
      display: flex;
      align-items: center;
      margin-bottom: 14px;

      .title {
        display: flex;
        align-items: center;
        // padding-left: 25px;
        padding-top: 28px;
        padding-bottom: 20px;
        // background-color: #35B1FF;
        font-weight: 500;
        font-size: 14px;
        color: #666666;
        // text-align: center;
        // height: 50px;
        // line-height: 50px;
        img {
          width: 32px;
          height: 32px;
          margin-right: 9px;
        }
      }
      .list {
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        width: 272px;
        height: 214px;
        padding: 0 25px;
        background: #fdfdfd;
        box-shadow: 0px 10px 15px 0px rgba(102, 102, 102, 0.1);
        border-radius: 8px;
        border: 1px solid #eeeeee;
        // border: 1px solid #35b1ff;

        border-radius: 8px;
        position: relative;
        .content {
          display: flex;
          align-items: center;
          // padding-right: 30px;
          // padding-top: 20px;
          position: relative;
          .el-icon-user {
            margin-left: 30px;
          }
        }
        .btn {
          padding-bottom: 24px;
          margin-top: 6px;
          // position: absolute;
          // height: 34px;
          // text-align: center;
          // left: 50%;
          // transform: translate(-50%, -50%);
          // bottom: 0;
          .custom-btn {
            background: rgba(63, 158, 255, 0.1);
            // box-shadow: 0px 10px 15px 0px rgba(102, 102, 102, 0.1);
            border-radius: 4px;
            width: 100%;
            height: 44px;
            border: none;
            font-weight: 400;
            font-size: 14px;
            color: #3f9eff;
            &:hover {
              font-weight: 400;
              font-size: 14px;
              color: #3f9eff;
            }
          }
        }
      }
      .el-icon-d-arrow-right {
        font-size: 36px;
        color: #666;
      }
      .el-form-item {
        margin-bottom: 0;
        .el-form-item__label {
          padding-right: 0px;
        }
      }
    }
    .add {
      width: 320px;
      height: 214px;
      border: 2px dotted #35b1ff;
      border-radius: 8px;
      display: flex;
      align-items: center;
      justify-content: center;
      text-align: center;
      margin-bottom: 14px;
      cursor: pointer;
      .el-icon-plus {
        font-size: 40px;
        color: #666;
      }
    }
  }
  .confirm-box {
    border-top: 1px solid #ededf0;
    padding-top: 8px;
    text-align: center;
    margin-top: 30px;
  }
}
/deep/.el-switch__label.is-active {
  font-weight: 400;
  font-size: 14px;
  color: #313133;
}
.next-step-icon {
  margin: 0 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  border-radius: 50%;
  background: #f8f8f8;
  i {
    color: #999999;
  }
}
</style>
